import React from 'react'
import { motion } from 'framer-motion';
import WEB1MOCKUP from '../../../../app/assets/images/projectImage/aiDoctorImage/web1Mockup.webp';
import APP1SCREEN from '../../../../app/assets/images/projectImage/aiDoctorImage/app1Screen.webp';

// Animation variants
const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const staggerContainer = {
    hidden: { opacity: 1 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
};

const hoverElevate = {
    y: -5,
    transition: { duration: 0.3 }
};

const AIDoctorProjectOverview = () => {
    return (
        <div className=''>
            <motion.div
                className='flex flex-col lg:flex-row items-end justify-end pt-12 sm:pt-16 md:pt-20 lg:pt-24 gap-6 md:gap-0'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
            >
                <motion.div
                    className='flex flex-col gap-4 w-full lg:w-auto order-2 lg:order-1'
                    variants={fadeInLeft}
                >
                    <motion.div
                        className='text-3xl text-center lg:text-left sm:text-4xl md:text-5xl font-bold leading-snug pl-4 sm:pl-10 md:pl-20 uppercase text-white'
                        variants={fadeInUp}
                    >
                        Overview
                    </motion.div>
                    <motion.div
                        className='text-white text-base sm:text-lg md:text-xl font-medium p-4 sm:p-6 md:p-8 lg:pl-20 pr-4 sm:pr-10 md:pr-16 leading-7 sm:leading-8 md:leading-9'
                        style={{
                            background: 'linear-gradient(135deg, #4B4AD5 0%, #A461D8 100%)',
                        }}
                        variants={fadeInUp}
                    >
                        Healthcare AI is a cross-platform healthcare assistant
                        designed to simplify medical interactions through a clean,
                        conversational interface. Built for both mobile and web,
                        healthcare AI helps users access vaccination data,
                        ask health-related questions, and engage with
                        AI-powered medical guidance in a secure
                        and intuitive environment.
                    </motion.div>
                </motion.div>
                <motion.div
                    className='w-full lg:w-auto order-1 lg:order-2'
                    variants={fadeInRight}
                    whileHover={hoverElevate}
                >
                    <img src={WEB1MOCKUP} alt='AIDoctorProjectOverview' className='w-full h-full object-cover' />
                </motion.div>
            </motion.div>

            <motion.div
                className='flex flex-col lg:flex-row items-center justify-center lg:pt-24 gap-6 md:gap-0'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
            >
                <motion.img
                    src={APP1SCREEN}
                    alt='AIDoctorProjectOverview'
                    className='w-full md:w-[50%] h-full object-cover order-1 md:order-1'
                    variants={fadeInLeft}
                    whileHover={hoverElevate}
                />

                <motion.div
                    className='flex flex-col gap-4 w-full md:w-auto order-2'
                    variants={fadeInRight}
                >
                    <motion.div
                        className='text-3xl text-center lg:text-left sm:text-4xl md:text-5xl font-bold leading-snug lg:pl-20 uppercase text-white'
                        variants={fadeInUp}
                    >
                        Problem Statement
                    </motion.div>
                    <motion.div
                        className='text-white text-sm sm:text-base md:text-lg font-medium p-4 sm:p-6 md:p-8 pl-4 sm:pl-10 md:pl-20 pr-4 sm:pr-10 md:pr-16 leading-6 sm:leading-7'
                        style={{
                            background: 'linear-gradient(135deg, #4B4AD5 0%, #A461D8 100%)',
                        }}
                        variants={fadeInUp}
                    >
                        Users struggle to find accurate medical information quickly. Traditional search
                        engines overwhelm with inconsistent results, medical jargon, & outdated
                        sources. Healthcare AI aims to solve this by offering:
                        <br />
                        <span className='flex flex-col gap-2 pt-2'>
                            <li className='pt-2 sm:pt-4'>
                                <b>Accurate, verified answers</b>
                            </li>
                            <li>
                                <b>A clean, distraction-free chat interface</b>
                            </li>
                            <li>
                                <b>Health guidance accessible to all ages</b>
                            </li>
                            <li>
                                <b>Uniform experience across phone and desktop</b>
                            </li>
                        </span>
                    </motion.div>
                </motion.div>
            </motion.div>
        </div>
    )
}

export default AIDoctorProjectOverview